import { SvgIcon } from "@material-ui/core";

export const LabelFilled = (props) => (
  <SvgIcon {...props} viewBox="-4 -4 24 24">
    <path d="M5.17393 5.17393H5.18228M16.5187 10.5249L10.5333 16.5103C10.3782 16.6656 10.1941 16.7887 9.99139 16.8727C9.78871 16.9568 9.57145 17 9.35204 17C9.13263 17 8.91538 16.9568 8.71269 16.8727C8.51001 16.7887 8.32588 16.6656 8.17082 16.5103L1 9.34787V1H9.34787L16.5187 8.17082C16.8296 8.48363 17.0042 8.90679 17.0042 9.34787C17.0042 9.78894 16.8296 10.2121 16.5187 10.5249Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
